function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
    // 生成随机时间
    function generateRandomTime() {
      var hours = Math.floor(Math.random() * 15) + 1
      var minutes = Math.floor(Math.random() * 60)
      var seconds = Math.floor(Math.random() * 60)
      //总共的毫秒数
      var targetTime = (hours * 3600 + minutes * 60 + seconds) * 1000

      return targetTime
    }
    function TimeDown(value) {
      //倒计时的总秒数
      var totalSeconds = parseInt(value / 1000)
      //取模（余数）
      var modulo = totalSeconds % (60 * 60 * 24)
      //小时数
      var hours = Math.floor(modulo / (60 * 60))
      modulo = modulo % (60 * 60)
      //分钟
      var minutes = Math.floor(modulo / 60)
      //秒
      var seconds = modulo % 60

      hours = hours.toString().length == 1 ? '0' + hours : hours
      minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
      seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

      //输出到页面
      $('.hours').html(hours)
      $('.minutes').html(minutes)
      $('.seconds').html(seconds)
      //延迟一秒执行自己
      if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
      } else {
        setTimeout(function () {
          TimeDown(value - 1000)
        }, 1000)
      }
    }
    TimeDown(generateRandomTime())
    // 头部固定
    $('header').addClass('stiky')
    $(document).scroll(function (e) {
      var beforScrollTop = $(document).scrollTop()
      setTimeout(function () {
        $('header').addClass('stiky')
      }, 50)
    })
    var swiper1 = new Swiper('.mySwiper', {
      loop: true,
      autoplay: {
        delay: 2000,
        stopOnLastSlide: false,
        disableOnInteraction: true,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    })
    var indexall = 0
    var indexall2 = 0
    // 数字框
    let prods = window.product
    // $('.product-part-inner #sp_price1').html((prods[0].price /100).toFixed(2))
    // $('.product-part-inner #sp_price2').html((prods[0].compare_at_price /100).toFixed(2))
    // $('.sp-mask #sp_price1').html((prods[0].price /100).toFixed(2))
    // $('.sp-mask #sp_price2').html((prods[0].compare_at_price /100).toFixed(2))
    function getCur(productPart) {
    //   let size = productPart.find('#size div.active').attr('data-val')
      let color = productPart.find('#color div.active').attr('data-val')
      return prods.filter(
        item => item.option1 == color 
      )[0]
    }
    function changePrice(productPart) {
      let num = productPart.find('#calcNumber').val()
      let price = ((getCur(productPart).price * num) / 100).toFixed(2)
      let compare = (
        (getCur(productPart).compare_at_price * num) /
        100
      ).toFixed(2)
      // price = (price + '').replace('.', ',')
      // compare = (compare + '').replace('.', ',')
      productPart.find('#new').html(price)
      productPart.find('#old').html(compare)
      let off_font =
        100 -
        Math.ceil(
          (getCur(productPart).price / getCur(productPart).compare_at_price) *
            100
        )
      $('.product-part .sp-frees .sp-off').html(off_font)
    }
    $('.sp-btn-style').click(function () {
      let productPart = $(this).closest('.product-part')
      let num = productPart.find('#calcNumber').val()
      window.location.href = '/cart/' + getCur(productPart).id + ':' + num
    })
    $('.reduce').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) - 1
      if (num > 0) {
        input.value = num
        let productPart = $(this).closest('.product-part')
        changePrice(productPart)
      }
    })
    $('.add').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) + 1
      input.value = num
      let productPart = $(this).closest('.product-part')
      changePrice(productPart)
    })
    // const tabs = $('.sp-tab')
    // let currentIndex = 0
    // function nextTabFunc() {
    //   const currentTab = tabs[currentIndex]
    //   currentTab.classList.add('sp-tab-ani')
    //   let nextIndex = (currentIndex + 1) % tabs.length
    //   const nextTab = tabs[nextIndex]
    //   setTimeout(() => {
    //     currentTab.classList.remove('sp-tab-ani')
    //   }, 2500),
    //     (currentIndex = (currentIndex + 1) % tabs.length),
    //     setTimeout(nextTabFunc, 1500)
    // }
    // nextTabFunc()
    var imgArr = [
      'https://cdn.shopify.com/s/files/1/0799/7397/4304/files/20250814-pro-1.png',
      'https://cdn.shopify.com/s/files/1/0799/7397/4304/files/20250814-pro-3.png',
      'https://cdn.shopify.com/s/files/1/0799/7397/4304/files/20250814-pro-2.png',
      'https://cdn.shopify.com/s/files/1/0799/7397/4304/files/20250814-img1.png',
      'https://cdn.shopify.com/s/files/1/0799/7397/4304/files/20250814-img2.png',
      'https://cdn.shopify.com/s/files/1/0799/7397/4304/files/20250814-img3.png',
      'https://cdn.shopify.com/s/files/1/0799/7397/4304/files/20250814-pro-4.png',
      'https://cdn.shopify.com/s/files/1/0799/7397/4304/files/20250814-pro-6.png',
      'https://cdn.shopify.com/s/files/1/0799/7397/4304/files/20250814-pro-5.png',
      'https://cdn.shopify.com/s/files/1/0799/7397/4304/files/20250814-img4.png',
      'https://cdn.shopify.com/s/files/1/0799/7397/4304/files/20250814-img5.png',
      'https://cdn.shopify.com/s/files/1/0799/7397/4304/files/20250814-img6.png',
      'https://cdn.shopify.com/s/files/1/0799/7397/4304/files/20250814-pro-7.png',
      'https://cdn.shopify.com/s/files/1/0799/7397/4304/files/20250814-pro-9.png',
      'https://cdn.shopify.com/s/files/1/0799/7397/4304/files/20250814-pro-8.png',
      'https://cdn.shopify.com/s/files/1/0799/7397/4304/files/20250814-img7.png',
      'https://cdn.shopify.com/s/files/1/0799/7397/4304/files/20250814-img8.png',
      'https://cdn.shopify.com/s/files/1/0799/7397/4304/files/20250814-img9.png',
      ,
    ]
    // style选项
    let typeOptions = $('#color .option')
    // 切换选项
    typeOptions.click(function () {
      let productPart = $(this).closest('.product-part')
      var index = $(this).index()
      var index2 = productPart.find('#size .option.active').index()
      $(this).addClass('active').siblings().removeClass('active')
      productPart
        .find('.top-product img')
        .attr('src', imgArr[index])
      if (index2 == 0) {
        productPart.find('.sp-gift').hide()
      } else if (index2 == 1) {
        productPart.find('.sp-gift').show()
        if (index > 2) {
          productPart.find('.sp-gift').css('bottom', '75px')
        } else {
          productPart.find('.sp-gift').css('bottom', '205px')
        }
      } else if (index2 == 2) {
        productPart.find('.sp-gift').show()
        if (index > 2) {
          productPart.find('.sp-gift').css('bottom', '18px')
        } else {
          productPart.find('.sp-gift').css('bottom', '113px')
        }
      }
      indexall = index
      indexall2 = index2
      changePrice(productPart)
    })
    // $('#color1 .option').click(function () {
    //   var index = $(this).index()
    //   var index2 = $('#Size1 .option.active').index()
    //   $(this).addClass('active').siblings().removeClass('active')
    //   changeOption(index, index2)
    //   indexall = index
    //   indexall2 = index2
    //   let productPart = $(this).closest('.product-part');
    // changePrice(productPart)
    // })
    $('#size .option').click(function () {
      let productPart = $(this).closest('.product-part')
      var index = productPart.find('#color .option.active').index()
      var index2 = $(this).index()
      $(this).addClass('active').siblings().removeClass('active')
      productPart
        .find('.top-product img')
        .attr('src', imgArr[index + index2 * 6])
      if (index2 == 0) {
        productPart.find('.sp-gift').hide()
      } else if (index2 == 1) {
        productPart.find('.sp-gift').show()
        if (index > 2) {
          productPart.find('.sp-gift').css('bottom', '75px')
        } else {
          productPart.find('.sp-gift').css('bottom', '205px')
        }
      } else if (index2 == 2) {
        productPart.find('.sp-gift').show()
        if (index > 2) {
          productPart.find('.sp-gift').css('bottom', '18px')
        } else {
          productPart.find('.sp-gift').css('bottom', '113px')
        }
      }
      indexall = index
      indexall2 = index2

      changePrice(productPart)
    })
    // $('#Size1 .option').click(function () {
    //   var index = $('#color1 .option.active').index()
    //   var index2 = $(this).index()
    //   $(this).addClass('active').siblings().removeClass('active')
    //   changeOption(index, index2)
    //   indexall = index
    //   indexall2 = index2
    //   let productPart = $(this).closest('.product-part');
    // changePrice(productPart)
    // })
    function changeOption(index, index2) {
      if (index2 == 0) {
        $('.top-product img').attr('src', imgArr[index + index2 * 6])
        $('.sp-gift').hide()
      } else if (index2 == 1) {
        $('.top-product img').attr('src', imgArr[index + index2 * 6])
        $('.sp-gift').show()
        $('.sp-gift').css('bottom', '205px')
      } else if (index2 == 2) {
        $('.top-product img').attr('src', imgArr[index + index2 * 6])
        $('.sp-gift').show()
        $('.sp-gift').css('bottom', '113px')
      }
    }
    $('.sp-part1-btns,.sp-head-btns,.sp-public-btn').click(function () {
      $('.sp-mask').css('display', 'flex')
      //   $('#color1 .option')
      //     .eq(indexall)
      //     .addClass('active')
      //     .siblings()
      //     .removeClass('active')
      //   $('#Size1 .option')
      //     .eq(indexall2)
      //     .addClass('active')
      //     .siblings()
      //     .removeClass('active')
      //   changeOption(indexall, indexall2)
    })
    $('.close-pop').click(function () {
      $('.sp-mask').css('display', 'none')
      //   $('#color1 .option')
      //     .eq(indexall)
      //     .addClass('active')
      //     .siblings()
      //     .removeClass('active')
      //   $('#Size1 .option')
      //     .eq(indexall2)
      //     .addClass('active')
      //     .siblings()
      //     .removeClass('active')
      //   changeOption(indexall, indexall2)
      //   $('#color .option')
      //     .eq(indexall)
      //     .addClass('active')
      //     .siblings()
      //     .removeClass('active')
      //   $('#size .option')
      //     .eq(indexall2)
      //     .addClass('active')
      //     .siblings()
      //     .removeClass('active')
      //   changeOption(indexall, indexall2)
    })
    // 加入购物车
    addCart()
    function addCart() {
      // 加入购物车
      $('.addCerts').click(function () {
        // do something here
        let $product = $(this).closest('.product-part')
        var data = {
          id: getCur($product).id,
          quantity: $product.find('#calcNumber').val(),
        }
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          success: function () {
            $.getJSON(
              window.Shopify.routes.root + 'cart.js',
              function (result) {
                $('#cardNum').html(result.item_count)
                if (result.item_count > 0) {
                  $('.sp-cart .num').css('background', '#cf0101')
                } else {
                  $('.sp-cart .num').css('background', '#919191')
                }
              }
            )
          },
          dataType: 'json',
        })

        var img = $('.top-product img')
        var flyer = img[0].cloneNode(true)
        flyer.classList.add('clone')
        $('.product-part').append(flyer)
        $('.clone').css({
          width: img.width(),
          height: img.height(),
          position: 'fixed',
          top: img[0].offsetTop,
          left: img.offset().left,
          'z-index': '999999',
        })
        var offset = $('.sp-cart')[0].getBoundingClientRect()
        $('.sp-cart').addClass('shake')
        setTimeout(() => {
          $('.sp-cart').removeClass('shake')
        }, 1000)
        let finish = $('.sp-cart')
        $('.clone').animate(
          {
            top: finish[0].offsetTop,
            left: finish[0].offsetLeft + finish.width() / 2 - 15,
            width: 50, // 结束时的大小，根据需要调整
            height: 50, // 结束时的大小，根据需要调整
            opacity: 0.4,
          },
          1000,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach() // 完成动画后移除克隆的图片
              }
            )
          }
        )
      })
    }
  })
  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach(subArray => {
        subArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach(url => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // preloadImages(imagesOneDim)
    // preloadImages(imagesTwoDim)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop - $('header').height()
        window.scroll({
          top: offsetTop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()
